import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getPayrollDetails = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/PayrollDetail/get`,
      filter,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in getPayrollDetails:", error);
    return {
      data: [],
      isSuccess: false,
      message: error.message
    };
  }
};

export const savePayrollDetail = async (model) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/PayrollDetail/save`,
      model,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in savePayrollDetail:", error);
    return {
      success: false,
      message: error.message
    };
  }
}; 